export const building = {
  building: {
    shape: `<path fill="#000" fill-opacity=".98" d="M5.05 20.15v-13H9.5V3.875L12 1.5l2.5 2.375v7.275h4.45v9H5.05Zm1-1h3v-3h-3v3Zm0-4h3v-3h-3v3Zm0-4h3v-3h-3v3Zm4.45 8h3v-3h-3v3Zm0-4h3v-3h-3v3Zm0-4h3v-3h-3v3Zm0-4h3v-3h-3v3Zm4.45 12h3v-3h-3v3Zm0-4h3v-3h-3v3Z"/>`,
    viewBox: [0, 0, 24, 24],
  },
};
